var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.347,
    height: 10.852,
    viewBox: "0 0 11.347 10.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star-svgrepo-com_4_",
    "data-name": "star-svgrepo-com (4)",
    d: "M6.222,1.387,7.5,3.981a.611.611,0,0,0,.46.334l2.862.416a.611.611,0,0,1,.339,1.042L9.092,7.792a.611.611,0,0,0-.176.541l.489,2.85a.611.611,0,0,1-.887.644l-2.56-1.346a.612.612,0,0,0-.569,0L2.83,11.827a.611.611,0,0,1-.887-.644l.489-2.85a.611.611,0,0,0-.176-.541L.186,5.773A.611.611,0,0,1,.525,4.731l2.862-.416a.611.611,0,0,0,.46-.334l1.28-2.593A.611.611,0,0,1,6.222,1.387Z",
    transform: "translate(-0.001 -1.047)",
    fill: "#0080ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarActive);
export default __webpack_public_path__ + "static/media/star-active.b86de1013e3131cef251803fccbce04b.svg";
export { ForwardRef as ReactComponent };